import { render, staticRenderFns } from "./new-password-form.vue?vue&type=template&id=5d1ea8ad&scoped=true&"
import script from "./new-password-form.vue?vue&type=script&lang=js&"
export * from "./new-password-form.vue?vue&type=script&lang=js&"
import style0 from "./new-password-form.vue?vue&type=style&index=0&id=5d1ea8ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1ea8ad",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CDivider: require('@chakra-ui/vue').CDivider, CBox: require('@chakra-ui/vue').CBox})
